module.exports = __webpack_public_path__ + "static/media/BD.2b57e84a.svg";